import { useCurrentUser } from "@qualio/ui-components";
import { useCurrentProduct } from "../useCurrentProduct";
import { useMutation, useQueryClient } from "react-query";
import { DesignElement } from "@design-controls/types";
import { designControlsApi } from "../../api/designControls";

export const useUpdateDesignElement = () => {
  const { companyId } = useCurrentUser();
  const { id: productId } = useCurrentProduct();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: Partial<DesignElement>) =>
      designControlsApi.modifyDesignElement(companyId, productId, data),
    onSuccess: async (_, data) => {
      await Promise.all([
        queryClient.invalidateQueries([
          "DESIGN_ELEMENT_BY_ID",
          companyId,
          productId,
          data.id,
          "v0",
        ]),
        queryClient.invalidateQueries([
          "DESIGN_ELEMENT_VERSIONS",
          companyId,
          productId,
          data.id,
        ]),
        queryClient.invalidateQueries([
          "OPEN_ISSUE_LIST",
          companyId,
          productId,
        ]),
      ]);
    },
  });
};
